/* The HUD: a transparent overlay that only takes pointer events on its own
   controls, so the deck underneath stays fully draggable. */

.hud {
  position: fixed;
  inset: 0;
  z-index: 10;
  pointer-events: none;
}

.hud > * {
  pointer-events: auto;
}

.topbar {
  position: absolute;
  top: calc(14px + var(--safe-t));
  left: calc(14px + var(--safe-l));
  right: calc(14px + var(--safe-r));
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}

/* The space between the pill and the gear, where the full-screen offer sits. */
.topbarMiddle {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--ink-3);
  box-shadow: 0 0 0 3px rgba(11, 31, 23, 0.06);
  flex: none;
  transition:
    background 0.3s,
    box-shadow 0.3s;
}

.live {
  background: var(--accent);
  box-shadow:
    0 0 0 3px var(--accent-soft),
    0 0 10px var(--accent-glow);
}

.label {
  max-width: 30vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The one-time full-screen offer: a question and two answers, in one pill. */
.offer {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  margin: 0;
  padding: 0 4px 0 16px;
  border: 0;
  min-inline-size: 0;
  border-radius: 999px;
  animation: offer-in 0.5s var(--ease) both;
}

.offerText {
  font-size: 13.5px;
  font-weight: 600;
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.offerYes,
.offerNo {
  height: 36px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 620;
  letter-spacing: -0.01em;
  white-space: nowrap;
  transition: transform 0.2s var(--ease);
}

.offerYes {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(180deg, var(--accent), var(--accent-deep));
  color: #fff;
  box-shadow:
    0 2px 8px var(--accent-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.offerYes svg {
  width: 16px;
  height: 16px;
  stroke-width: 2;
}

.offerNo {
  color: var(--ink-2);
}

.offerYes:active,
.offerNo:active {
  transform: scale(0.95);
}

@keyframes offer-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.rail {
  position: absolute;
  left: calc(14px + var(--safe-l));
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (max-width: 620px) {
  .rail {
    top: auto;
    bottom: calc(104px + var(--safe-b));
    transform: none;
    flex-direction: row;
  }

  .label {
    max-width: 26vw;
  }
}

@media (max-height: 460px) and (orientation: landscape) {
  .rail {
    gap: 8px;
  }
}
